export enum ErrorType {
  MINIMUM_ORDER_AMOUNT = 'MINIMUM_ORDER_AMOUNT',
  GIFT_CARD = 'GIFT_CARD',
  COUPON = 'COUPON',
  GENERAL = 'GENERAL',
  PAYMENT = 'PAYMENT',
  EXTERNAL_CARRIER_ERROR = 'EXTERNAL_CARRIER_ERROR',
}

export const CouponErrorCodes: Record<string, string> = {
  ERROR_COUPON_DOES_NOT_EXIST: 'ERROR_COUPON_DOES_NOT_EXIST',
  ERROR_COUPON_IS_NOT_ACTIVE_YET: 'ERROR_COUPON_IS_NOT_ACTIVE_YET',
  ERROR_COUPON_HAS_EXPIRED: 'ERROR_COUPON_HAS_EXPIRED',
  ERROR_COUPON_USAGE_EXCEEDED: 'ERROR_COUPON_USAGE_EXCEEDED',
  ERROR_COUPON_IS_DISABLED: 'ERROR_COUPON_IS_DISABLED',
  ERROR_INVALID_COMMAND_FIELD: 'ERROR_INVALID_COMMAND_FIELD',
  ERROR_COUPON_LIMIT_PER_CUSTOMER_EXCEEDED: 'ERROR_COUPON_LIMIT_PER_CUSTOMER_EXCEEDED',
  ERROR_INVALID_SUBTOTAL: 'ERROR_INVALID_SUBTOTAL',
  ERROR_INVALID_PRODUCTS: 'ERROR_INVALID_PRODUCTS',
  ERROR_INVALID_PRODUCT_QUANTITY: 'ERROR_INVALID_PRODUCT_QUANTITY',
  ERROR_NOT_APPLICABLE_FOR_SUBSCRIPTIONS: 'ERROR_NOT_APPLICABLE_FOR_SUBSCRIPTIONS',
  COUPON_CANNOT_BE_USED_TO_PURCHASE_GIFT_CARD: 'COUPON_CANNOT_BE_USED_TO_PURCHASE_GIFT_CARD',
};

export const GiftCardErrorCodes: Record<string, string> = {
  GIFT_CARD_CODE_INVALID: 'GIFT_CARD_CODE_INVALID',
  GIFT_CARD_EXPIRED: 'GIFT_CARD_EXPIRED',
  GIFT_CARD_INSUFFICIENT_BALANCE: 'GIFT_CARD_INSUFFICIENT_BALANCE',
  GIFT_CARD_IS_EMPTY: 'GIFT_CARD_IS_EMPTY',
  GIFT_CARD_UNSUPPORTED_STATUS: 'GIFT_CARD_UNSUPPORTED_STATUS',
  GIFT_CARD_GENERAL_ERROR: 'GIFT_CARD_GENERAL_ERROR',
  GIFT_CARD_CURRENCY_INVALID: 'GIFT_CARD_CURRENCY_INVALID',
  GIFT_CARD_DISABLED: 'GIFT_CARD_DISABLED',
  GIFT_CARD_SERVICE_UNAVAILABLE: 'GIFT_CARD_SERVICE_UNAVAILABLE',
  GIFT_CARD_CANNOT_BE_USED_TO_PURCHASE_GIFT_CARD: 'GIFT_CARD_CANNOT_BE_USED_TO_PURCHASE_GIFT_CARD',
};

export const GeneralCheckoutErrorCode: Record<string, string> = {
  EMPTY_CHECKOUT: 'EMPTY_CHECKOUT',
  FULL_OUT_OF_STOCK: 'FULL_OUT_OF_STOCK',
  PARTIAL_OUT_OF_STOCK: 'PARTIAL_OUT_OF_STOCK',
  CHECKOUT_ALREADY_PAID: 'CHECKOUT_ALREADY_PAID',
  NO_SELECTED_CARRIER_SERVICE_OPTION: 'NO_SELECTED_CARRIER_SERVICE_OPTION',
  CALCULATION_ERROR: 'CALCULATION_ERROR',
  VIOLATIONS_WITH_ERROR_SEVERITY: 'VIOLATIONS_WITH_ERROR_SEVERITY',
  CHECKOUT_CHANGED: 'CHECKOUT_CHANGED',
  GENERAL_ERROR: 'GENERAL_ERROR',
};

export const PaymentErrorCode: Record<string, string> = {
  CHECKOUT_PAYMENT_ALREADY_IN_PROGRESS: 'CHECKOUT_PAYMENT_ALREADY_IN_PROGRESS',
  PAYMENT_ERROR: 'PAYMENT_ERROR',
  EWALLET_ERROR: 'EWALLET_ERROR',
  CUSTOM_PAYMENT_ERROR: 'CUSTOM_PAYMENT_ERROR',
  NON_SUFFICIENT_FUNDS: 'NON_SUFFICIENT_FUNDS',
};

export const ExternalErrorCode: Record<string, string> = {
  NO_SHIPPING: 'NO_SHIPPING',
};

export const MinimumOrderAmountErrorCode: Record<string, string> = {
  MINIMUM_ORDER_AMOUNT_NOT_REACHED: 'MINIMUM_ORDER_AMOUNT_NOT_REACHED',
};

export const ClientErrorCode: Record<string, string> = {
  CLIENT_EMPTY_CART: 'CLIENT_EMPTY_CART',
  CLIENT_FULL_OUT_OF_STOCK: 'CLIENT_FULL_OUT_OF_STOCK',
  CLIENT_PAYMENT_ERROR: 'CLIENT_PAYMENT_ERROR',
  CLIENT_CART_CHANGED: 'CLIENT_CART_CHANGED',
};

export const CheckoutErrorCodeV1: Record<string, string> = {
  ...CouponErrorCodes,
  ...GiftCardErrorCodes,
  ...GeneralCheckoutErrorCode,
  ...MinimumOrderAmountErrorCode,
  ...PaymentErrorCode,
  ...ExternalErrorCode,
  ...ClientErrorCode,
};

export const AddCouponErrorCode: Record<string, string> = {
  INVALID_COUPON_CODE: 'INVALID_COUPON_CODE',
  INVALID_COUPON_STATUS: 'INVALID_COUPON_STATUS',
};

export const InvalidCouponReason: Record<string, string> = {
  UNKNOWN_INVALID_COUPON_REASON: 'UNKNOWN_INVALID_COUPON_REASON',
  EXPIRED: 'EXPIRED',
  DISABLED: 'DISABLED',
  INACTIVE: 'INACTIVE',
  MAX_USAGE_EXCEEDED: 'MAX_USAGE_EXCEEDED',
  MAX_USAGE_PER_CUSTOMER_EXCEEDED: 'MAX_USAGE_PER_CUSTOMER_EXCEEDED',
  NOT_APPLICABLE_TO_SUBSCRIPTIONS: 'NOT_APPLICABLE_TO_SUBSCRIPTIONS',
  NOT_APPLICABLE_TO_SELECTED_LINE_ITEMS: 'NOT_APPLICABLE_TO_SELECTED_LINE_ITEMS',
  MIN_LINE_ITEM_QUANTITY_NOT_REACHED: 'MIN_LINE_ITEM_QUANTITY_NOT_REACHED',
  MIN_SUBTOTAL_NOT_REACHED: 'MIN_SUBTOTAL_NOT_REACHED',
};

export const GeneralErrorCode: Record<string, string> = {
  GENERAL_ERROR: 'GENERAL_ERROR',
};

export const AddGiftCardErrorCode: Record<string, string> = {
  INVALID_GIFT_CARD_CODE: 'INVALID_GIFT_CARD_CODE',
  INVALID_GIFT_CARD_STATUS: 'INVALID_GIFT_CARD_STATUS',
};

export const InvalidGiftCardReason: Record<string, string> = {
  UNKNOWN_INVALID_GIFT_CARD_REASON: 'UNKNOWN_INVALID_GIFT_CARD_REASON',
  EXPIRED: 'EXPIRED',
  DISABLED: 'DISABLED',
  EMPTY_BALANCE: 'EMPTY_BALANCE',
};

interface Action {
  name: string;
  fn: () => void;
}

export interface ErrorProps {
  title: string;
  description: string;
  action: Action;
}
